import Box from "@mui/material/Box"
import dynamic from "next/dynamic"
import useCartHandler from '@components/_hooks/Cart/useCartHandler'
import useCartActions from '@components/_hooks/Cart/useCartActions'
import usePadActions from '@components/_hooks/Cart/usePadActions'
import useWindowSize from "@components/_hooks/useWindowSize"
import { count, isDefined } from "@components/config/helpers"

const ProductCardHeader = dynamic(() => import('./ProductCardHeader'))
const ProductCardKeyFeatures = dynamic(() => import('./ProductCardKeyFeatures'))
const ProductAddToCart = dynamic(() => import('./ProductAddToCart'))
const ProductHeading = dynamic(() => import('../ProductHeading'))
const ProductAccordions = dynamic(() => import( '../ProductAccordions'))
const ProductVariants = dynamic(() => import('../ProductCard/Variants/ProductVariants'))
const ProductCardAddonGroups = dynamic(() => import('./ProductCardAddonGroups'))

const ProductCard = (props) => {
    const {
        product,
        long_term_product,
        price_breaks,
        productData,
        product_variants,
        widths,
        depth,
        height,
        source,
        activeTab,
        measurements,
        key_features,
        videos,
        faqs,
        articles,
        long_desc,
        reviews,
        addon_groups,
        template_page_settings,
    } = props;



     const {
        addToCart
     } = useCartHandler();

     const {
        handleQtyChange,
        qty, 
        setQty,
     } = useCartActions();

     const {
        padSelector,
        setShowPadSelector,
        handlePadSelector,
        select,
        handleExtra
     } = usePadActions();
     
    //  console.log(productData)
     const {isMobile } = useWindowSize();

     const showDimensions = (widths && widths != null) && (depth && depth != null) && (height && height != null) ? true : false;


    
  return (
    <Box className={``}>
           { !isMobile && 
            <ProductHeading 
                product={product} 
                product_rating={product.product_rating}
                product_rating_count={product.product_rating_count}
                template_page_settings={template_page_settings}
            />
        }
           {isDefined(product_variants) && count(product_variants) > 1 && isMobile && <ProductVariants product_id={product.product_id} product_variants={product_variants}/>}
            {
                showDimensions ? (
                    <>
                        <ProductCardHeader
                            widths={widths}
                            depth={depth}
                            height={height}
                        />
                    </>
                ) : (
                    null
                )
            }

            {isDefined(addon_groups) && count(addon_groups) > 0 && (
                <Box 
                    className='w-100'
                >
                    <ProductCardAddonGroups addon_groups={addon_groups}/>
                </Box>
            )}

            <ProductAddToCart
                cartControls={{
                    addToCart,
                    handleQtyChange,
                    padSelector,
                    setShowPadSelector,
                    handlePadSelector,
                    select,
                    qty,
                    setQty,
                    handleExtra
                }}
                product={product}
                source={source}
                props={productData} 
            />

            <ProductCardKeyFeatures
                product={product}
                long_term_product={long_term_product}
                key_features={product.ext_attributes.key_feature}
                price_breaks={price_breaks}
            />


            {/* <ParseHtml html={product.product_description_short}/> */}

            {isMobile && activeTab != null && (
                <ProductAccordions 
                    measurements={measurements}
                    key_features={key_features}
                    videos={videos}
                    articles={articles}
                    reviews={reviews}
                    faqs={faqs}
                    product={product}
                    long_term_product={long_term_product}
                    long_desc={long_desc}
                    width={widths}
                    depth={depth}
                    height={height}
                />
            )}



            {isDefined(product_variants) && count(product_variants) > 1 && !isMobile && <ProductVariants product_id={product.product_id} product_variants={product_variants}/>}

        </Box>
  )
}

export default ProductCard